<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#3CB043" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs11 sm11 pt-5>
        <v-layout wrap>
          <v-flex xs6 sm6 md8 text-left>
            <span
              style="
                color: #1f1f1f;
                font-family: poppinssemibold;
                font-size: 20px;
              "
              >My Orders</span
            >
          </v-flex>
          <!-- <v-flex xs6 sm6 md4 text-right>
            <v-text-field
              solo
              dense
              flat
              prepend-inner-icon="mdi-magnify"
              background-color="#F5F5F5"
              color="#787878"
              placeholder="Search orders"
            >
            </v-text-field>
          </v-flex> -->
        </v-layout>
        <v-layout wrap v-if="orders.length > 0" justify-center py-2>
          <v-flex xs12 py-4 v-for="(list, l) in orders" :key="l">
            <v-card>
              <v-layout wrap justify-start py-3 px-5>
                <v-flex xs12 py-2>
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 sm6 md4 lg4 text-right>
                      <v-layout wrap>
                        <v-flex text-start>
                          <v-chip
                            color="#F3F3F3"
                            text-color="#0D76D8"
                            style="
                              font-size: 13px;
                              font-family: poppinssemibold;
                            "
                          >
                            <span
                              style="
                                color: black;
                                font-family: poppinsregular;
                                font-size: 13px;
                                font-family: poppinssemibold;
                              "
                            >
                              Order&nbsp;
                            </span>

                            #{{ list.transactionId }}
                          </v-chip>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm6 md5 lg4 text-right>
                      <v-layout wrap>
                        <!-- <v-flex xs12 align-self-center v-if="list.status=='pending'">
                          <span style="color: black; font-family: poppinsregular;font-size:15px">Order Placed on {{
                            list.orderplacedDate }}</span>
                        </v-flex>
                        <v-flex xs12 align-self-center v-if="list.status=='cancelled'">
                          <span style="color: black; font-family: poppinsregular;font-size:15px">Order Cancelled on {{
                            list.orderCancelDate }}</span>
                        </v-flex> -->

                        <v-flex
                          xs12
                          align-self-center
                          v-if="list.status == 'cancelled'"
                        >
                          <span
                            style="
                              color: black;
                              font-family: poppinsregular;
                              font-size: 15px;
                            "
                            >Order Cancelled on {{ list.orderCancelDate }}</span
                          >
                        </v-flex>
                        <v-flex xs12 align-self-center v-else>
                          <span
                            style="
                              color: black;
                              font-family: poppinsregular;
                              font-size: 15px;
                            "
                            >Order Placed on {{ list.orderplacedDate }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md3 lg4 text-right>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span
                            style="
                              color: black;
                              font-family: poppinsregular;
                              font-size: 13px;
                              font-family: poppinssemibold;
                            "
                            >Status :
                            <span
                              style="
                                color: #f28f34;
                                font-size: 13px;
                                font-family: poppinssemibold;
                              "
                            >
                              {{ list.status }}
                            </span></span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 py-4>
                  <v-divider></v-divider>
                </v-flex>

                <v-flex xs12 py-2 pt-3 v-for="(item, i) in list.items" :key="i">
                  <v-layout wrap>
                    <!-- <v-flex xs3 sm2 v-if="item.productImage">
                      <v-img :src="mediaURL + item.productImage" height="100px" width="100%" contain
                        style="border-radius: 30px" :alt="item.productName">
                        <template v-slot:placeholder>
                          <ImageLoader />
                        </template>
                      </v-img>

                    </v-flex> -->

                    <v-flex xs12 sm2 v-if="item.productImage">
                      <v-card
                        elevation="0"
                        rounded="xl"
                        color="#F5F5F5"
                        class="pa-4"
                      >
                        <router-link
                          :to="
                            '/productDetails?productName=' +
                            item.productName +
                            '&id=' +
                            item.productId
                          "
                        >
                          <v-layout row align-center justify-center>
                            <v-flex
                              xs6
                              md8
                              sm8
                              lg8
                              class="d-flex justify-center align-center"
                            >
                              <v-img
                                :src="mediaURL + item.productImage[0]"
                                height="100px"
                                width="100px"
                                contain
                                :alt="item.productName"
                              >
                                <template v-slot:placeholder>
                                  <ImageLoader />
                                </template>
                              </v-img>
                            </v-flex>
                          </v-layout>
                        </router-link>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm10 md10 lg10>
                      <v-layout wrap justify-center>
                        <v-flex xs11 sm11 md11 align-self-center text-left>
                          <v-layout
                            wrap
                            justify-start
                            style="line-height: 16px"
                            fill-height
                          >
                            <v-flex xs9 sm10 md10 text-left>
                              <span
                                style="
                                  font-family: poppinsbold;
                                  font-size: 15px;
                                  color: #191919;
                                "
                                >{{ item.productName }}</span
                              >
                            </v-flex>
                            <v-flex
                              xs3
                              sm2
                              md2
                              pl-0
                              pl-xs-0 pl-sm-5 pl-md-5 pl-lg-10 pl-xl-10
                              text-left
                              v-if="list.status == 'completed'"
                            >
                              <v-btn
                                small
                                outlined
                                @click="openAddDialog(item)"
                              >
                                <span
                                  style="
                                    font-family: opensanssemibold;
                                    font-size: 12px;
                                    text-transform: capitalize;
                                  "
                                  >
                                  <!-- <v-icon small>mdi-pencil</v-icon> -->
                                  Review</span
                                >
                              </v-btn>
                            </v-flex>
                            <v-flex xs12>
                              <span
                                style="
                                  color: #191919;
                                  font-size: 13px;
                                  font-family: poppinssemibold;
                                "
                                >Category :
                                <span
                                  style="
                                    color: #191919;
                                    font-size: 13px;
                                    font-family: poppinsmedium;
                                  "
                                >
                                  {{ item.productCategory }}</span
                                >
                                &nbsp; </span
                              ><span
                                style="
                                  color: #191919;
                                  font-size: 13px;
                                  font-family: poppinssemibold;
                                "
                              >
                                Quantity :
                                <span
                                  style="
                                    color: #191919;
                                    font-size: 13px;
                                    font-family: poppinsmedium;
                                  "
                                >
                                  {{ item.Qty }}</span
                                ></span
                              >
                            </v-flex>
                            <v-flex xs12 pt-1>
                              <span
                                style="
                                  color: #191919;
                                  font-size: 13px;
                                  font-family: poppinssemibold;
                                "
                                >Size :
                                <span
                                  style="
                                    color: #191919;
                                    font-size: 13px;
                                    font-family: poppinsmedium;
                                  "
                                >
                                  {{ item.productSize }}
                                </span>
                              </span>
                            </v-flex>

                            <v-layout row wrap xs12 pt-1>
                              <!-- Shop Name -->
                              <v-flex xs12 sm6 md6 lg6>
                                <span
                                  style="
                                    color: #f28f34;
                                    font-size: 13px;
                                    font-family: poppinssemibold;
                                  "
                                >
                                  Sold by :
                                  <span
                                    style="
                                      color: #191919;
                                      font-size: 13px;
                                      font-family: poppinsmedium;
                                    "
                                  >
                                    {{ item.shopName }}
                                  </span>
                                </span>
                              </v-flex>

                              <!-- Price, Centered -->
                              <v-flex
                                xs12
                                sm6
                                md6
                                lg6
                                pt-2
                                pt-lg-0
                                pt-sm-0
                                pt-md-0
                                d-flex
                                justify-center
                              >
                                <span
                                  style="
                                    color: #191919;
                                    font-size: 17px;
                                    font-family: poppinssemibold;
                                  "
                                >
                                  ₹ {{ item.totalAmt }}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 py-2>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- <v-flex xs12 md3 sm4 lg3 py-2>
                  <v-btn rounded dark color="#30B868" :to="'/Profile/orderDetails?id=' + list.orderId">
                    <span style="font-family: opensanssemibold; font-size: 13px">View Order</span>
                  </v-btn>
                </v-flex> -->

                <v-flex xs12 md3 sm4 lg2 py-2>
                  <v-btn
                    rounded
                    dark
                    elevation="0"
                    color="#30B868"
                    :to="'/Profile/orderDetails?id=' + list.orderId"
                  >
                    <span
                      style="
                        font-family: opensanssemibold;
                        font-size: 13px;
                        text-transform: none;
                      "
                      >View Order</span
                    >
                  </v-btn>
                </v-flex>

                <v-flex xs12 md3 sm4 lg2 py-2 v-if="list.status == 'pending'">
                  <v-btn
                    rounded
                    dark
                    elevation="0"
                    color="#444645"
                    @click="openDeleteDialog(list.orderId)"
                  >
                    <span
                      style="
                        font-family: opensanssemibold;
                        font-size: 13px;
                        text-transform: none;
                      "
                      >Cancel Order</span
                    >
                  </v-btn>
                </v-flex>
                <!-- <v-flex xs12 md3 sm4 lg2 py-2 v-if="list.status == 'pending'">
                  <v-btn rounded dark color="#444645" @click="dialog=true" >
                    <span style="font-family: opensanssemibold; font-size: 13px">Add Review</span>
                  </v-btn>

                </v-flex> -->
                <v-flex text-end pt-2>
                  <v-layout wrap justify-end>
                    <v-flex xs12 pb-4 text-end>
                      <span
                        style="
                          color: #3d3b3b;
                          font-family: poppinsmedium;
                          font-size: 14px;
                        "
                        >Total:</span
                      >
                      <!-- <span style="color: #383838; font-family: poppinsmedium">₹ {{ list.items.reduce((total, item) => total + item.totalAmt, 0) }}</span> -->
                      &nbsp;
                      <span style="color: #383838; font-family: poppinsbold">
                        ₹ {{ list.paymentAmount }}</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

        <v-flex xs12 sm12 v-else align-self-center pt-5>
          <span
            style="
              font-family: poppinsregular;
              font-size: 18px;
              color: #000000;
              cursor: pointer;
            "
            >Oops! No Order Found</span
          >
        </v-flex>
        <v-layout wrap justify-center pt-2>
          <v-flex xs12>
            <div class="text-center pb-5" v-if="pages > 1">
              <v-pagination
                :length="pages"
                :total-visible="7"
                v-model="currentPage"
                color="#30B868"
                circle
              ></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogConfirm" max-width="600px">
      <v-card>
        <v-card-title
          style="font-family: poppinsregular; font-size: 15px; color: #000"
          >Are you sure you want to cancel this order?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text small @click="dialogConfirm = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text small @click="confirmDelete"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-layout wrap pa-5>
          <v-flex xs11 pb-2 text-left>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 15px;
                color: #191919;
              "
            >
              Rate this product
            </span>
          </v-flex>
          <v-flex xs1 text-right class="pa-0">
            <v-icon color="red" @click="dialog = false">mdi-close</v-icon>
          </v-flex>
          <v-flex xs12 sm12 text-left>
            <v-rating
              color="#F28F34"
              background-color="#F28F34"
              half-increments
              size="30px"
              hover
              v-model="rating"
            ></v-rating>
          </v-flex>
          <v-flex xs12 py-2 text-left>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 15px;
                color: #191919;
              "
            >
              Share your thoughts on this product.
            </span>
          </v-flex>
          <v-flex xs12 sm12 text-left>
            <v-textarea outlined rows="3" v-model="review"> </v-textarea>
          </v-flex>
          <v-flex xs12 text-right align-self-end pb-5>
            <v-btn color="#30B868" dark @click="confirmAddReview">
              <span style="font-family: opensanssemibold; text-transform: none">
                Post Review
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      page: 1,
      currentPage: 1,
      pages: 0,
      limit: 5,
      cart: {
        cart: [],
      },
      searchKey: null,
      dialogConfirm: false,
      dialog: false,
      review: "",
      rating: "",
      pincode: null,
      items: ["1", "2", "3", "4"],
      lists: [
        {
          image: require("./../../assets/images/product5.png"),
          category: "Personal Care",
          name: "Softening Creamy Soap Bar",
          quantity: "100 Gm",
          offerprice: "₹ 120",
          price: "(₹ 180)",
        },
      ],
      orders: [],
      itemToDelete: null,
      itemToAdd: null,
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/order/list",
        params: {
          limit: this.limit,
          page: this.currentPage,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.orders = response.data.data; // Directly assigning the updated data structure
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    // getData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/user/order/list",
    //     params: {
    //       limit: this.limit,
    //       page: this.currentPage,
    //     },
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       this.orders = response.data.data;
    //       this.pages = Math.ceil(response.data.totalLength / this.limit);
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      // day = day < 10 ? "0" + day : day;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
    openDeleteDialog(orderId) {
      this.itemToDelete = orderId; // Set the specific orderId
      this.dialogConfirm = true;
    },
    confirmDelete() {
      if (this.itemToDelete) {
        this.cancelOrder(this.itemToDelete); // Pass orderId directly to cancelOrder
      }
      this.dialogConfirm = false;
    },
    cancelOrder(orderId) {
      // Accept orderId as a parameter
      axios({
        method: "POST",
        url: "user/order/cancel",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          orderId: orderId, // Use the passed orderId
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.dialogConfirm = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    openAddDialog(item) {
      this.itemToAdd = item.productId; // Set the specific orderId
      this.rating = item.rating;
      this.review = item.review;
      this.dialog = true;
    },

    confirmAddReview() {
      if (this.itemToAdd) {
        this.addReview(this.itemToAdd); // Pass orderId directly to cancelOrder
      }
      this.dialog = false;
    },
    addReview(productId) {
      // Accept orderId as a parameter
      axios({
        method: "POST",
        url: "user/product/AddReview",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productId: productId, // Use the passed orderId
          rating: this.rating, // Add the rating value
          review: this.review, // Add the review text
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.dialog = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.getData();
            this.rating = null;
            this.review = null;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>